import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { ROUTES_CONSTANTS } from "routes/route-constants";
import { logo_bam_std, bg_image } from "assets/images/images";
import CustomButton from "components/widgets/custom-button/CustomButton.js";
import { titles } from "constants/titles";
import { getData } from "utility";
import keys from "constants/keys";
import { getDashboardMenuList } from "redux/Common/action";
import "./LandingScreen.css";
import { ACCESS_TOKEN, ADMIN_ACCESS_TOKEN } from "redux/auth/actionTypes";

export const LandingScreen = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    getUserInfo();
  }, []);

  useEffect(() => {
    history.push(history.location.pathname);
    history.replace(history.location.pathname);
  }, [history]);

  const getUserInfo = async () => {
    let accessToken = await getData(keys?.accessTokenKey);
    let adminAccessToken = await getData(keys?.adminAccessTokenKey);
    if (accessToken?.length > 0) {
      dispatch({
        type: ACCESS_TOKEN,
        payload: accessToken,
      });
      dispatch({
        type: ADMIN_ACCESS_TOKEN,
        payload: adminAccessToken,
      });
      getDashboardMenuList(dispatch);
      history?.push(ROUTES_CONSTANTS.home);
    } else if (adminAccessToken?.length > 0) {
      dispatch({
        type: ADMIN_ACCESS_TOKEN,
        payload: adminAccessToken,
      });
      history?.push(ROUTES_CONSTANTS.customerLogin);
    }
  };

  return (
    <div className="landing_screen_container">
      <div className="landing_background">
        <img
          src={bg_image}
          alt="background"
          className="landing_background_image"
        />
        <div className="landing_background_overlay"></div>
      </div>

      <div className="landing_content">
        <div className="landing_logo_container">
          <img src={logo_bam_std} alt="Bay Alarm Medical Logo" />
        </div>

        <h1 className="display_h1">
          {titles?.number_one_alert_system} <br />
          {titles?.medical_alert_system}
        </h1>

        <div className="landing_action_buttons">
          <CustomButton
            className="landing_login_button display_h3"
            text={titles?.admin_sign_in}
            onClick={() => history.push(ROUTES_CONSTANTS.login)}
          />

          {/* <button 
            className="display_h2 landing_guest_signin_link"
            onClick={() => history.push(ROUTES_CONSTANTS.customerLogin)}
          >
            {titles?.guest_sign_in}
          </button> */}
        </div>

        <div className="landing_footer_copyright">
          <p className="text-white-color body_h2">
            {titles?.bay_alarm_medical}
          </p>
          <p className="text-white-color body_h2">
            {titles?.all_rights_reserved}
          </p>
        </div>
      </div>
    </div>
  );
};

export default LandingScreen;
